// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__u7Lc9","date":"style_date__i0IVr","date_fromTo":"style_date_fromTo__MCqF8","date_error":"style_date_error__iTtqR","delete":"style_delete__3MIX6"};